import React, { useState, useEffect, useContext } from 'react';
import { 
  Container, Typography, Box, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, Paper, TextField, 
  Button, MenuItem, Alert, CircularProgress, IconButton,
  Collapse, List, ListItem, ListItemText, Dialog, DialogTitle,
  DialogContent, DialogActions
} from '@mui/material';
import { 
  KeyboardArrowDown as KeyboardArrowDownIcon, 
  KeyboardArrowUp as KeyboardArrowUpIcon,
  PictureAsPdf as PdfIcon,
  Info as InfoIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Axios from 'axios';
import config, { environment } from '../config';
import StateContext from '../Contexts/StateContext';
import XXVICall from '../Assets/Docs/XXVI-ik SZEKELYFOLDI Geologus  Találkozó – Nyárádszereda.pdf';

const meetingsData = [
  { number: 'I.', year: 1999, date: '', location: 'Sepsiszentgyörgy', material_count: 0 },
  { number: 'II.', year: 2000, date: 'november 11', location: 'Sepsiszentgyörgy', material_count: 0 },
  { number: 'III.', year: 2001, date: '', location: '', material_count: 0 },
  { number: 'IV.', year: 2002, date: '', location: '', material_count: 0 },
  { number: 'V.', year: 2003, date: '', location: '', material_count: 0 },
  { number: 'VI.', year: 2004, date: 'okt. 23-26', location: 'Csíkszereda', material_count: 0 },
  { number: 'VII.', year: 2005, date: 'okt. 28-30', location: 'Csíkszereda', material_count: 0 },
  { number: 'VIII.', year: 2006, date: 'okt. 26-29', location: 'Csíkszereda', material_count: 0 },
  { number: 'IX.', year: 2007, date: 'okt. 26-27', location: 'Csíkszereda', material_count: 0 },
  { number: 'X.', year: 2008, date: 'okt. 23-26', location: 'Csíkszereda', material_count: 0 },
  { number: 'XI.', year: 2009, date: 'okt. 22-25', location: 'Székelyudvarhely', material_count: 0 },
  { number: 'XII.', year: 2010, date: 'okt. 29-30', location: 'Barót', material_count: 0 },
  { number: 'XIII.', year: 2011, date: 'szept. 22-25', location: 'Gyergyószentmiklós', material_count: 0 },
  { number: 'XIV.', year: 2012, date: 'okt. 19-21', location: 'Marosvásárhely', material_count: 0 },
  { number: 'XV.', year: 2013, date: 'okt. 24-27', location: 'Kézdivásárhely', material_count: 0 },
  { number: 'XVI.', year: 2014, date: 'okt. 23-26', location: 'Várfalva (Aranyosszék)', material_count: 0 },
  { number: 'XVII.', year: 2015, date: 'okt. 22-24', location: 'Székelykeresztúr', material_count: 0 },
  { number: 'XVIII.', year: 2016, date: 'okt. 28-30', location: 'Kovászna', material_count: 0 },
  { number: 'XIX.', year: 2017, date: 'okt. 27-29', location: 'Borszék', material_count: 0 },
  { number: 'XX.', year: 2018, date: 'okt. 25-28', location: 'Sepsiszentgyörgy', material_count: 0 },
  { number: 'XXI.', year: 2019, date: 'okt. 24-27', location: 'Szováta', material_count: 0 },
  { number: 'XXII.', year: 2022, date: 'okt. 27-30', location: 'Szentegyháza', material_count: 0 },
  { number: 'XXIII.', year: 2023, date: 'okt. 16-19', location: 'Tusnádfürdő', material_count: 0 },
  { number: 'XXIV.', year: 2024, date: 'okt. 24-27', location: 'Piricske (Mountain Resort)', material_count: 0 },
  { number: 'XXV.', year: 2025, date: 'okt. 23-26', location: 'Csíkszereda', material_count: 0 },
  { number: 'XXVI.', year: 2026, date: 'október 22-25', location: 'Nyárádszereda', material_count: 0 },
];

function Row(props) {
  const { meeting, t, i18n, GlobalState, onUpdate, authorFilter } = props;
  const [open, setOpen] = useState(false);
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  
  // Edit form state
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editTitle, setEditTitle] = useState('');
  const [editTitleEn, setEditTitleEn] = useState('');
  const [editAuthors, setEditAuthors] = useState('');
  const [editAbstract, setEditAbstract] = useState('');
  const [editFile, setEditFile] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [editStatus, setEditStatus] = useState({ type: '', message: '' });

  // Delete dialog state
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [materialToDelete, setMaterialToDelete] = useState(null);

  const fetchMaterials = async () => {
    if (!open && meeting.id) {
      setLoading(true);
      try {
        const response = await Axios.get(`${config[environment].meetingsEndpoint}materials/?meeting=${meeting.id}`);
        setMaterials(response.data);
      } catch (error) {
        console.error("Error fetching materials:", error);
      } finally {
        setLoading(false);
      }
    }
    setOpen(!open);
  };

  useEffect(() => {
    if (authorFilter && meeting.id && materials.length === 0 && !loading) {
      const autoFetch = async () => {
        setLoading(true);
        try {
          const response = await Axios.get(`${config[environment].meetingsEndpoint}materials/?meeting=${meeting.id}`);
          setMaterials(response.data);
        } catch (error) {
          console.error("Error auto-fetching materials:", error);
        } finally {
          setLoading(false);
        }
      };
      autoFetch();
    }
  }, [authorFilter, meeting.id, materials.length, loading]);

  const isOwner = (material) => {
      return material && GlobalState.userIsLogged && GlobalState.userUsername === material.username;
  };

  const filteredMaterials = authorFilter 
    ? materials.filter(m => (m.authors && m.authors.toLowerCase().includes(authorFilter.toLowerCase())) || (m.username && m.username.toLowerCase().includes(authorFilter.toLowerCase())))
    : materials;

  useEffect(() => {
    if (authorFilter && filteredMaterials.length > 0) {
      setOpen(true);
    }
  }, [authorFilter, filteredMaterials.length]);

  const handleOpenDetails = (material) => {
    setSelectedMaterial(material);
    setDetailsDialogOpen(true);
  };

  const handleVisualize = (presentationUrl) => {
    window.open(presentationUrl, '_blank');
  };

  const handleOpenEdit = (material) => {
    setSelectedMaterial(material);
    setEditTitle(material.title || '');
    setEditTitleEn(material.title_en || '');
    setEditAuthors(material.authors || '');
    setEditAbstract(material.abstract || '');
    setEditFile(null);
    setEditStatus({ type: '', message: '' });
    setEditDialogOpen(true);
  };

  const containsImages = (text) => {
    const imagePattern = /<img|!\[.*\]\(.*\)|data:image\//i;
    return imagePattern.test(text);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (containsImages(editAbstract)) {
      setEditStatus({ type: 'error', message: t('SZGT.AbstractNoImages') });
      return;
    }
    setIsUpdating(true);
    const formData = new FormData();
    formData.append('meeting', selectedMaterial.meeting);
    formData.append('title', editTitle);
    formData.append('title_en', editTitleEn);
    formData.append('authors', editAuthors);
    formData.append('abstract', editAbstract);
    if (editFile) {
        formData.append('presentation', editFile);
    }

    try {
        const token = GlobalState.jwtAccessToken || localStorage.getItem('jwtAccessToken');
        const response = await Axios.patch(`${config[environment].meetingsEndpoint}materials/${selectedMaterial.id}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        });
        setEditStatus({ type: 'success', message: t('SZGT.UpdateSuccess') });
        // Update local state
        setMaterials(materials.map(m => m.id === selectedMaterial.id ? response.data : m));
        setTimeout(() => setEditDialogOpen(false), 1500);
    } catch (error) {
        console.error("Update error:", error);
        setEditStatus({ type: 'error', message: t('SZGT.UploadError') });
    } finally {
        setIsUpdating(false);
    }
  };

  const handleOpenDelete = (material) => {
      setMaterialToDelete(material);
      setDeleteDialogOpen(true);
  };

  const handleDelete = async () => {
      try {
          const token = GlobalState.jwtAccessToken || localStorage.getItem('jwtAccessToken');
          await Axios.delete(`${config[environment].meetingsEndpoint}materials/${materialToDelete.id}/`, {
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });
          setMaterials(materials.filter(m => m.id !== materialToDelete.id));
          setDeleteDialogOpen(false);
      } catch (error) {
          console.error("Delete error:", error);
      }
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} hover onClick={fetchMaterials} style={{ cursor: 'pointer' }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small">
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {meeting.number}{meeting.number.endsWith('.') ? '' : '.'}
        </TableCell>
        <TableCell>{i18n.language.startsWith('hu') ? `${meeting.year}.` : meeting.year}</TableCell>
        <TableCell>{meeting.date}</TableCell>
        <TableCell>{meeting.location}</TableCell>
        <TableCell align="center">{meeting.material_count || 0}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {loading ? (
                <CircularProgress size={24} />
              ) : filteredMaterials.length > 0 ? (
                <List sx={{ mt: 1 }}>
                  {filteredMaterials.map((material) => (
                    <ListItem key={material.id} divider
                      secondaryAction={
                        <Box>
                          <IconButton edge="end" aria-label="details" onClick={(e) => { e.stopPropagation(); handleOpenDetails(material); }} sx={{ mr: 1 }}>
                            <InfoIcon color="primary" />
                          </IconButton>
                          {material.presentation && (
                            <IconButton edge="end" aria-label="pdf" onClick={(e) => { e.stopPropagation(); handleVisualize(material.presentation); }} sx={{ mr: 1 }}>
                              <PdfIcon color="error" />
                            </IconButton>
                          )}
                          {isOwner(material) && (
                              <>
                                <IconButton edge="end" aria-label="edit" onClick={(e) => { e.stopPropagation(); handleOpenEdit(material); }} sx={{ mr: 1 }}>
                                    <EditIcon color="action" />
                                </IconButton>
                                <IconButton edge="end" aria-label="delete" onClick={(e) => { e.stopPropagation(); handleOpenDelete(material); }}>
                                    <DeleteIcon color="error" />
                                </IconButton>
                              </>
                          )}
                        </Box>
                      }
                    >
                      <ListItemText 
                        primary={material.title} 
                        secondary={material.authors ? `${material.authors} | ${material.username}` : material.username} 
                      />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Typography variant="body2" sx={{ fontStyle: 'italic', py: 1 }}>
                  {authorFilter ? t('SZGT.NoMatch') : t('App.UnderConstruction')}
                </Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      {/* Details Dialog */}
      <Dialog open={detailsDialogOpen} onClose={() => setDetailsDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>{selectedMaterial?.title}</DialogTitle>
        <DialogContent dividers>
            {selectedMaterial?.title_en && (
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">{t('SZGT.MaterialTitleEn')}:</Typography>
                    <Typography variant="body1">{selectedMaterial.title_en}</Typography>
                </Box>
            )}
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">{t('SZGT.Authors')}:</Typography>
                <Typography variant="body1">{selectedMaterial?.authors || selectedMaterial?.username}</Typography>
            </Box>
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">{t('SZGT.Abstract')}:</Typography>
                <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>{selectedMaterial?.abstract}</Typography>
            </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailsDialogOpen(false)} color="primary">
            {t('SZGT.Close')}
          </Button>
          {isOwner(selectedMaterial) && (
            <>
              <Button 
                onClick={() => {
                    setDetailsDialogOpen(false);
                    handleOpenEdit(selectedMaterial);
                }} 
                color="info"
                startIcon={<EditIcon />}
              >
                {t('SZGT.Edit')}
              </Button>
              <Button 
                onClick={() => {
                    setDetailsDialogOpen(false);
                    handleOpenDelete(selectedMaterial);
                }} 
                color="error"
                startIcon={<DeleteIcon />}
              >
                {t('SZGT.Delete')}
              </Button>
            </>
          )}
          {selectedMaterial?.presentation && (
            <Button 
                startIcon={<PdfIcon />} 
                variant="contained" 
                color="error"
                onClick={() => handleVisualize(selectedMaterial.presentation)}
            >
                {t('SZGT.Visualize')}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>{t('SZGT.Edit')}</DialogTitle>
          <DialogContent dividers>
              {editStatus.message && (
                  <Alert severity={editStatus.type} sx={{ mb: 2 }}>{editStatus.message}</Alert>
              )}
              <TextField
                  fullWidth
                  label={t('SZGT.MaterialTitle')}
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                  required
                  sx={{ mb: 2, mt: 1 }}
              />
              <TextField
                  fullWidth
                  label={t('SZGT.MaterialTitleEn')}
                  value={editTitleEn}
                  onChange={(e) => setEditTitleEn(e.target.value)}
                  sx={{ mb: 2 }}
              />
              <TextField
                  fullWidth
                  label={t('SZGT.Authors')}
                  value={editAuthors}
                  onChange={(e) => setEditAuthors(e.target.value)}
                  sx={{ mb: 2 }}
              />
              <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label={t('SZGT.Abstract')}
                  value={editAbstract}
                  onChange={(e) => setEditAbstract(e.target.value)}
                  sx={{ mb: 1 }}
              />
              <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 2 }}>
                  {t('SZGT.AbstractTextOnly')}
              </Typography>
              <Box>
                  <Typography variant="body2" gutterBottom>
                      {t('SZGT.PresentationFile')} ({t('SZGT.LeaveEmptyIfNoChange')})
                  </Typography>
                  <input
                      type="file"
                      accept=".pdf,.ppt,.pptx"
                      onChange={(e) => setEditFile(e.target.files[0])}
                  />
              </Box>
          </DialogContent>
          <DialogActions>
              <Button onClick={() => setEditDialogOpen(false)}>{t('SZGT.Close')}</Button>
              <Button onClick={handleUpdate} variant="contained" disabled={isUpdating}>
                  {isUpdating ? <CircularProgress size={24} /> : t('SZGT.Edit')}
              </Button>
          </DialogActions>
      </Dialog>

      {/* Delete Confirmation */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
          <DialogTitle>{t('SZGT.Delete')}</DialogTitle>
          <DialogContent>
              <Typography>{t('SZGT.ConfirmDelete')}</Typography>
          </DialogContent>
          <DialogActions>
              <Button onClick={() => setDeleteDialogOpen(false)}>{t('SZGT.Cancel')}</Button>
              <Button onClick={handleDelete} color="error" variant="contained">{t('SZGT.Delete')}</Button>
          </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

function Talalkozo() {
  const { t, i18n } = useTranslation();
  const GlobalState = useContext(StateContext);
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [authorFilter, setAuthorFilter] = useState('');
  
  // Current date for comparison
  const now = new Date();

  // Helper to check if a meeting is in the past
  const isPastMeeting = (meeting) => {
    if (!meeting.year) return true;
    
    // If year is past, it's definitely past
    if (meeting.year < now.getFullYear()) return true;
    
    // If year is future, it's definitely future
    if (meeting.year > now.getFullYear()) return false;
    
    if (meeting.year === 2026 && meeting.date.includes('okt')) {
        const meetingMonth = 9; // October (0-indexed)
        if (now.getMonth() < meetingMonth) return false;
        const dayMatch = meeting.date.match(/(\d+)/);
        if (dayMatch) {
            const startDay = parseInt(dayMatch[1]);
            if (now.getMonth() === meetingMonth && now.getDate() < startDay) return false;
        }
    }

    return true;
  };

  const pastMeetings = meetings.filter(m => isPastMeeting(m));
  const futureMeetings = meetings.filter(m => !isPastMeeting(m));
  
  // Upload form state
  const [selectedMeeting, setSelectedMeeting] = useState('');
  const [title, setTitle] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [authors, setAuthors] = useState('');
  const [abstract, setAbstract] = useState('');
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState({ type: '', message: '' });
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    async function fetchMeetings() {
      try {
        const response = await Axios.get(config[environment].meetingsEndpoint);
        if (response.data && response.data.length > 0) {
          setMeetings(response.data);
        } else {
          setMeetings(meetingsData);
        }
      } catch (error) {
        console.error("Error fetching meetings:", error);
        setMeetings(meetingsData);
      } finally {
        setLoading(false);
      }
    }
    fetchMeetings();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 5 * 1024 * 1024) {
      setUploadStatus({ type: 'error', message: t('SZGT.FileTooLarge') });
      setFile(null);
    } else {
      setFile(selectedFile);
      setUploadStatus({ type: '', message: '' });
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!GlobalState.userIsLogged) {
      setUploadStatus({ type: 'error', message: t('SZGT.LoginRequired') });
      return;
    }

    const containsImages = (text) => {
      const imagePattern = /<img|!\[.*\]\(.*\)|data:image\//i;
      return imagePattern.test(text);
    };

    if (containsImages(abstract)) {
      setUploadStatus({ type: 'error', message: t('SZGT.AbstractNoImages') });
      return;
    }

    setIsUploading(true);
    const formData = new FormData();
    formData.append('meeting', selectedMeeting);
    formData.append('title', title);
    formData.append('title_en', titleEn);
    formData.append('authors', authors);
    formData.append('abstract', abstract);
    if (file) {
      formData.append('presentation', file);
    }

    try {
      const token = GlobalState.jwtAccessToken || localStorage.getItem('jwtAccessToken');
      await Axios.post(config[environment].meetingsUploadEndpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        }
      });
      setUploadStatus({ type: 'success', message: t('SZGT.UploadSuccess') });
      // Reset form
      setSelectedMeeting('');
      setTitle('');
      setTitleEn('');
      setAuthors('');
      setAbstract('');
      setFile(null);
    } catch (error) {
      console.error("Upload error:", error);
      setUploadStatus({ type: 'error', message: t('SZGT.UploadError') });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom color="primary">
        {t('SZGT.Title')}
      </Typography>

      {GlobalState.userIsLogged ? (
        <Box component={Paper} sx={{ p: 3, mb: 6 }}>
          <Typography variant="h5" gutterBottom>
            {t('SZGT.UploadTitle')}
          </Typography>
          {uploadStatus.message && (
            <Alert severity={uploadStatus.type} sx={{ mb: 2 }}>
              {uploadStatus.message}
            </Alert>
          )}
          <Box component="form" onSubmit={handleUpload}>
            <TextField
              select
              fullWidth
              label={t('SZGT.SelectMeeting')}
              value={selectedMeeting}
              onChange={(e) => setSelectedMeeting(e.target.value)}
              required
              sx={{ mb: 2 }}
            >
              {meetings.map((meeting) => (
                <MenuItem key={meeting.id || meeting.number} value={meeting.id || meeting.number}>
                  {meeting.number}{meeting.number.endsWith('.') ? '' : '.'} SZGT ({meeting.year})
                </MenuItem>
              ))}
            </TextField>
            <TextField
              fullWidth
              label={t('SZGT.MaterialTitle')}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label={t('SZGT.MaterialTitleEn')}
              value={titleEn}
              onChange={(e) => setTitleEn(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label={t('SZGT.Authors')}
              value={authors}
              onChange={(e) => setAuthors(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              multiline
              rows={4}
              label={t('SZGT.Abstract')}
              value={abstract}
              onChange={(e) => setAbstract(e.target.value)}
              sx={{ mb: 1 }}
            />
            <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 2 }}>
                {t('SZGT.AbstractTextOnly')}
            </Typography>
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" gutterBottom>
                {t('SZGT.PresentationFile')}
              </Typography>
              <input
                type="file"
                accept=".pdf,.ppt,.pptx"
                onChange={handleFileChange}
              />
            </Box>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary"
              disabled={isUploading}
            >
              {isUploading ? <CircularProgress size={24} /> : t('SZGT.UploadButton')}
            </Button>
          </Box>
        </Box>
      ) : (
        <Alert severity="info" sx={{ mb: 6 }}>{t('SZGT.LoginRequired')}</Alert>
      )}

      {futureMeetings.length > 0 && (
        <Box sx={{ mb: 6 }}>
          <Typography variant="h5" gutterBottom color="secondary">
            {t('SZGT.UpcomingTitle')}
          </Typography>
          <TableContainer component={Paper} sx={{ backgroundColor: '#fffde7', border: '2px solid #fbc02d' }}>
            <Table aria-label="upcoming szgt table">
              <TableHead sx={{ backgroundColor: 'secondary.main' }}>
                <TableRow>
                  <TableCell />
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t('SZGT.MeetingNumber')}</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t('SZGT.Year')}</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t('SZGT.Date')}</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t('SZGT.Location')}</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">{t('SZGT.MaterialCount')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {futureMeetings.map((meeting, index) => (
                  <Row key={index} meeting={meeting} t={t} i18n={i18n} GlobalState={GlobalState} authorFilter={authorFilter} />
                ))}
              </TableBody>
            </Table>
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 2 }}>
                    {t('SZGT.UpcomingPromo')}
                </Typography>
                <Button 
                    variant="contained" 
                    color="secondary" 
                    startIcon={<PdfIcon />}
                    href={XXVICall}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('SZGT.DownloadCall')}
                </Button>
            </Box>
          </TableContainer>
        </Box>
      )}

      <Box sx={{ mb: 6 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5">
            {t('SZGT.ListTitle')}
          </Typography>
          <TextField
            size="small"
            label={t('SZGT.AuthorFilter')}
            value={authorFilter}
            onChange={(e) => setAuthorFilter(e.target.value)}
            sx={{ width: { xs: '100%', sm: '300px' } }}
          />
        </Box>
        {loading ? (
          <CircularProgress />
        ) : (
          <TableContainer component={Paper}>
            <Table aria-label="szgt table">
              <TableHead sx={{ backgroundColor: 'primary.main' }}>
                <TableRow>
                  <TableCell />
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t('SZGT.MeetingNumber')}</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t('SZGT.Year')}</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t('SZGT.Date')}</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>{t('SZGT.Location')}</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="center">{t('SZGT.MaterialCount')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pastMeetings.map((meeting, index) => (
                  <Row key={index} meeting={meeting} t={t} i18n={i18n} GlobalState={GlobalState} authorFilter={authorFilter} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Container>
  );
}

export default Talalkozo;
